@use "variables" as *;

.number {
  font-size: $fontSize-xl;
  font-weight: bold;
  width: 40px;
}

.incrementalButton {
  font-size: $fontSize-xl;
  font-weight: bolder;
}

.description {
  font-size: $fontSize-m;
  margin-bottom: $spacing-s;
}

.counter {
  margin-bottom: $spacing-s;
}
